import { useMutation, useQueryClient } from "@tanstack/react-query";
import { stockApi } from "@/lib/stock.api";
import { queryKeys } from "@/lib/query-keys";

export function useRestockArticleMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      type,
      quantity,
      responsibleAgentId,
    }: {
      id: number;
      type: "IN" | "ADJUST";
      quantity: number;
      responsibleAgentId?: number;
    }) => stockApi.restock(id, type, quantity, responsibleAgentId).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.stock() });
      queryClient.invalidateQueries({ queryKey: queryKeys.stockMovements() });
    },
  });
}
